import React, { useState, Fragment } from 'react';
import axios from 'axios';
import { UnsubscribePage } from './UnsubscribePage/UnsubscribePage';
import { ConfirmationPage } from './ConfirmationPage/ConfirmationPage';
import { ErrorPage } from '../ErrorHandler/ErrorPage/ErrorPage';
import { Header } from './Header/Header';
import { Footer } from './Footer/Footer';
import SubscriptionStatus from './SubscriptionStatus';

export const OptOut = () => {
  const [subscriptionStatus, setSubscriptionStatus] = useState(
    SubscriptionStatus.SUBSCRIBED,
  );

  const getMcdDcsIdFromPath = () => {
    // eslint-disable-next-line no-restricted-globals
    const mcdDcsId = location.pathname.substr(location.pathname.lastIndexOf('/') + 1);
    axios
      .post(
        `/api/unsubscribe/${mcdDcsId}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      .then(
        () => setSubscriptionStatus(SubscriptionStatus.UNSUBSCRIBED),
        () => setSubscriptionStatus(SubscriptionStatus.ERROR),
      )
      .catch(() => setSubscriptionStatus(SubscriptionStatus.ERROR));
  };

  const renderPageBasingOnSubscriptionStatus = () => {
    switch (subscriptionStatus) {
    case SubscriptionStatus.SUBSCRIBED:
      return <UnsubscribePage onUnsubscribe={getMcdDcsIdFromPath} />;
    case SubscriptionStatus.UNSUBSCRIBED:
      return <ConfirmationPage />;
    default:
      return <ErrorPage />;
    }
  };

  return (
    <Fragment>
      <Header />
      { renderPageBasingOnSubscriptionStatus() }
      <Footer
        isConfirmation={subscriptionStatus === SubscriptionStatus.UNSUBSCRIBED}
      />
    </Fragment>
  );
};
